<app-breadcrumb></app-breadcrumb>
<div class="container" *ngIf="theme$ | async as theme">
  <div class="main-container-version">
    <!-- Coming Soon Section -->
    <div class="section">
      <div class="flex w-full justify-content-between p-2">
        <div class="category">Coming Soon</div>
        <button class="mark-read-btn" (click)="onMarkAllRead('features')" [disabled]="featuresReadDisabled">
          Mark All Read
        </button>
      </div>
      <div class="accordion-container">
        <p-accordion [value]="100" [dt]="versionAccordion">
          @for (feature of futureFeatures; track $index; let last = $last) {
            @if(feature.visible) {
              <p-accordion-panel [value]="feature.id">
                <p-accordion-header (click)="onGroupItemSelected(feature, 'feature')">
                  <div class="accordion-header">
                    <span>{{feature.name}}</span>
                    @if(feature.isNew) {
                    <p-badge value="New!" severity="warn" class="ml-auto mr-2"></p-badge>
                    }
                  </div>
                </p-accordion-header>
                <p-accordion-content
                  [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
                  <div class="content-container">
                    <p class="version-description-text m-0">
                      {{feature.description}}
                    </p>
                  </div>
                </p-accordion-content>
              </p-accordion-panel>
              @if (!last && futureFeatures.length >= 1) {
                <div class="h-divider"></div>
              }
            }
          }
        </p-accordion>
      </div>
      <!-- Known Issues -->
      <div class="flex w-full justify-content-between p-2">
        <div class="category">Known Issues</div>
        <button class="mark-read-btn" (click)="onMarkAllRead('issues')" [disabled]="issuesReadDisabled">
          Mark All Read
        </button>
      </div>
      <div class="accordion-container">
        <p-accordion [value]="100" [dt]="versionAccordion">
          @for (issue of knownIssues; track $index; let last = $last) {
            <p-accordion-panel [value]="issue.id">
              <p-accordion-header (click)="onGroupItemSelected(issue, 'issue')">
                <div class="accordion-header">
                  <span>{{issue.name}}</span>
                  @if(issue.isNew) {
                    <p-badge value="New!" severity="warn" class="ml-auto mr-2"></p-badge>
                  }
                </div>
              </p-accordion-header>
              <p-accordion-content
                [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
                <div class="content-container">
                  <p class="version-description-text m-0">
                    {{issue.description}}
                  </p>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            @if(!last && knownIssues.length >= 1) {
              <div class="h-divider"></div>
            }
          }
        </p-accordion>
      </div>
      <!-- Version History -->
      <div class="flex w-full justify-content-between p-2">
        <div class="category">Versions</div>
        <button class="mark-read-btn" (click)="onMarkAllRead('versions')" [disabled]="versionsReadDisabled">
          Mark All Read
        </button>
      </div>
      <div class="accordion-container">
        <p-accordion [value]="100" [dt]="versionAccordion">
          @for (version of versionData; track $index; let last = $last) {
            <p-accordion-panel [value]="version.id">
              <p-accordion-header (click)="onGroupItemSelected(version, 'version')">
                <div class="accordion-header">
                  <div class="w-6rem">
                    <div class="flex justify-content-between">
                      <span>{{version.version}}</span>
                      @if (version.beta) {
                      <p-badge value="Beta" severity="success"></p-badge>
                      }
                    </div>
    
                  </div>
                  @if (version.isNew) {
                  <p-badge value="New!" severity="warn" class="ml-auto mr-2"></p-badge>
                  }
                </div>
              </p-accordion-header>
              <p-accordion-content
                [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
                <div class="content-container">
                  <div class="release-row">
                    <div class="description-label">Release Date:</div>
                    <div class="release-date">
                      {{ version.releaseDate }}
                    </div>
                  </div>
                  <div class="description-row">
                    <div class="description-label">Description:</div>
                    <div class="version-description-text">
                      {{ version.description }}
                    </div>
                  </div>
                  <div class="list-column">
                    <div class="description-label">Features:</div>
                    <ul>
                      @for (feature of version.features; track $index) {
                      <li class="accordion-item-content-text">
                        {{ feature }}
                      </li>
                      }
                    </ul>
                  </div>
                  <div class="list-column">
                    <div class="description-label">Fixes:</div>
                    <ul>
                      @for (fix of version.fixes; track $index) {
                      <li class="accordion-item-content-text">
                        {{ fix }}
                      </li>
                      }
                    </ul>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            @if(!last && versionData.length > 1) {
              <div class="h-divider"></div>
            }
          }
        </p-accordion>
      </div>
    </div>
  </div>
</div>